import { render } from "./AllPlayersListV2.vue?vue&type=template&id=485df2a8"
import script from "./AllPlayersListV2.vue?vue&type=script&lang=js"
export * from "./AllPlayersListV2.vue?vue&type=script&lang=js"

import "./AllPlayersListV2.vue?vue&type=style&index=0&id=485df2a8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__